import { useUserProfile } from "@providers/profile";
import { UserAddress } from "@providers/profile/ProfileProvider.model";
import { isEmptyObj } from "@utils/isEmptyObj";
import { ButtonWrap } from "../Account.styled";

export interface AddressInfoProps {
  address?: UserAddress;
  onToggle: (e: any) => void;
}

const AddressInfo = ({ address, onToggle }: AddressInfoProps) => {
  const {
    profileState: { profile },
  } = useUserProfile();

  const shipText = "Billing";

  return (
    <div>
      {address && !address?.error && !isEmptyObj(address) ? (
        <address>
          {address.name && (
            <>
              <strong>{address.name}</strong>
              <br />
            </>
          )}
          {address.line1}
          {address.line2 && [<br key={0} />, address.line2]}
          <br />
          {address.city}, {address.state} {address.postal_code}
        </address>
      ) : (
        <div>No Address on File</div>
      )}
      <ButtonWrap>
        <button onClick={onToggle}>
          {address ? `Update ${shipText} Address` : `Add ${shipText} Address`}
        </button>
      </ButtonWrap>
    </div>
  );
};

export default AddressInfo;
